<template>
    <div class="graphic-device">
        <slot />
        <svg v-if="shape === 1" class="graphic-device__shape graphic-device__shape--1" viewBox="0 0 156 141" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#graphic-a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M-164.999 132.226a9 9 0 0 0 9 9h93.093a9 9 0 0 0 9-9v-31.049a9 9 0 0 1 9-9h31.409a9 9 0 0 1 9 9v31.049a9 9 0 0 0 9 9H42.05a9 9 0 0 0 9-9v-31.049a9 9 0 0 1 9-9H91.39a9 9 0 0 1 9 9v31.049a9 9 0 0 0 9 9h37.547a9 9 0 0 0 9-9V98.292a9 9 0 0 0-9-9h-34.461a9 9 0 0 1-9-9V52.13a9 9 0 0 1 9-9h34.461a9 9 0 0 0 9-9V.195a9 9 0 0 0-9-9h-34.461a9 9 0 0 1-9-9v-31.048a9 9 0 0 0-9-9H56.93a9 9 0 0 0-9 9v33.933a9 9 0 0 0 9 9h34.461a9 9 0 0 1 9 9v28.163a9 9 0 0 1-9 9h-34.46a9 9 0 0 0-9 9v31.05a9 9 0 0 1-9 9H7.621a9 9 0 0 1-9-9v-31.05a9 9 0 0 0-9-9h-34.887a9 9 0 0 1-9-9V.195a9 9 0 0 0-9-9h-37.547a9 9 0 0 0-9 9V34.13a9 9 0 0 0 9 9h34.887a9 9 0 0 1 9 9v28.163a9 9 0 0 1-9 9h-90.074a9 9 0 0 0-9 9v33.934Z" fill="currentColor"/></g><defs><clipPath id="graphic-a"><path fill="#fff" d="M0 0h156v141H0z"/></clipPath></defs></svg> <!-- eslint-disable-line -->

        <svg v-if="shape === 2" class="graphic-device__shape graphic-device__shape--2" viewBox="0 0 179 250" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#graphic-b)"><path fill-rule="evenodd" clip-rule="evenodd" d="M375 251a9 9 0 0 1-9 9H254.192a9 9 0 0 1-9-9v-46.057a9 9 0 0 0-9-9h-39.731a9 9 0 0 0-9 9V251a9 9 0 0 1-9 9h-46.904a9 9 0 0 1-9-9v-46.058a9 9 0 0 0-9-9H73.904a9 9 0 0 0-9 9V251a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9v-49.826a9 9 0 0 1 9-9h43.298a9 9 0 0 0 9-9v-42.289a9 9 0 0 0-9-9H9a9 9 0 0 1-9-9V73.058a9 9 0 0 1 9-9h43.298a9 9 0 0 0 9-9V9a9 9 0 0 1 9-9h46.904a9 9 0 0 1 9 9v49.826a9 9 0 0 1-9 9H73.904a9 9 0 0 0-9 9v42.29a9 9 0 0 0 9 9h43.298a9 9 0 0 1 9 9v46.058a9 9 0 0 0 9 9h39.614a9 9 0 0 0 9-9v-46.057a9 9 0 0 1 9-9h43.797a9 9 0 0 0 9-9V73.059a9 9 0 0 1 9-9h46.904a9 9 0 0 1 9 9v49.826a9 9 0 0 1-9 9H257.72a9 9 0 0 0-9 9v42.289a9 9 0 0 0 9 9H366a9 9 0 0 1 9 9V251Z" fill="currentColor"/></g><defs><clipPath id="graphic-b"><path fill="#fff" d="M0 0h179v250H0z"/></clipPath></defs></svg> <!-- eslint-disable-line -->

        <svg v-if="shape === 3" class="graphic-device__shape graphic-device__shape--3" viewBox="0 0 275 161" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#graphic-c)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 214.8a9 9 0 0 0 9 9h99.692a9 9 0 0 0 9-9v-37.139a9 9 0 0 1 9-9h34.343a9 9 0 0 1 9 9V214.8a9 9 0 0 0 9 9h40.847a9 9 0 0 0 9-9v-37.14a9 9 0 0 1 9-9h34.272a9 9 0 0 1 9 9v37.14a9 9 0 0 0 9 9H331a9 9 0 0 0 9-9v-40.383a9 9 0 0 0-9-9h-37.577a9 9 0 0 1-9-9v-33.895a9 9 0 0 1 9-9H331a9 9 0 0 0 9-9V64.14a9 9 0 0 0-9-9h-37.577a9 9 0 0 1-9-9V9a9 9 0 0 0-9-9h-40.846a9 9 0 0 0-9 9v40.383a9 9 0 0 0 9 9h37.577a9 9 0 0 1 9 9v33.895a9 9 0 0 1-9 9h-37.577a9 9 0 0 0-9 9v37.139a9 9 0 0 1-9 9H182.34a9 9 0 0 1-9-9v-37.139a9 9 0 0 0-9-9h-38.029a9 9 0 0 1-9-9V64.14a9 9 0 0 0-9-9H67.465a9 9 0 0 0-9 9v40.382a9 9 0 0 0 9 9h38.029a9 9 0 0 1 9 9v33.895a9 9 0 0 1-9 9H9a9 9 0 0 0-9 9V214.8Z" fill="currentColor"/></g><defs><clipPath id="graphic-c"><path fill="#fff" d="M0 0h275v161H0z"/></clipPath></defs></svg> <!-- eslint-disable-line -->
    </div>
</template>

<script setup>
defineProps({
    shape: {
        type: Number,
        default: 1
    }
});
</script>

<style lang="less" scoped>
.graphic-device {
    position: relative;
    display: inline-block;
    overflow: hidden;
    color: var(--color-darkest);
    border-radius: 9px;
    height: 100%;
    min-height: 27vw;
    max-height: 40vh;

    :deep(picture), :deep(img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: var(--object-position, center);
    }
}

.graphic-device.image-fill-md {
    @media @q-md-min {
        :deep(img) {
            position: absolute;
        }
    }
}

.graphic-device__shape {
    position: absolute;
}

.graphic-device__shape--1 {
    height: 40%;
    top: -1px;
    left: -1px;
}

.graphic-device__shape--2 {
    height: 60%;
    bottom: -1px;
    right: -1px;
}

.graphic-device__shape--3 {
    height: 50%;
    bottom: -1px;
    right: -1px;
}
</style>
